import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getHubTenantHubConfig = async ({ rootGetters }, { displayName }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.getHubTenantHubConfig(displayName);
  return response.hubConfig;
};
